import { INFLUENCER_SHOPPABLE_POST_CUSTOMER_VIEW } from 'constants/influencerPages';
import { makeAscii } from 'helpers/index';
import { DimensionId, ProductStockData, ProductStyle, ValueIDToName } from 'types/cloudCatalog';
import { InfluencerContent, InStockMap, SelectedDimensions, SelectMenuOption } from 'types/influencer';
import { INFLUENCER_CONTENT_TYPE } from 'constants/amethystEnums';
import { FormattedProductBundle } from 'reducers/detail/productDetail';

export const getInStockValues = (
  selectedDimensions: SelectedDimensions,
  dimensionsSet: DimensionId[],
  stockData: ProductStockData[],
  colorId: string
): InStockMap => {
  const inStockMap: InStockMap = {};
  dimensionsSet.forEach((dimension: string) => {
    const stockArray: string[] = stockData.map(stockEntry => {
      if (stockEntry.onHand === '0' || stockEntry.color !== colorId) return '';
      const isStockEntryForSelectedDimensions = Object.keys(selectedDimensions).every(
        selectedDimension => selectedDimension === dimension || selectedDimensions[selectedDimension] === stockEntry[selectedDimension]
      );
      if (!isStockEntryForSelectedDimensions) {
        return '';
      } else {
        return stockEntry[dimension]!;
      }
    });
    inStockMap[dimension] = new Set(stockArray);
  });
  return inStockMap;
};

export const formatDropdownNames = (
  dimensionValues: string[],
  valueIdToName: Record<string, ValueIDToName>,
  inStockValuesForDimension: Set<string> | undefined
): SelectMenuOption[] =>
  dimensionValues.map((dimensionValue: string) => ({
    value: dimensionValue,
    label: valueIdToName[dimensionValue]!.value,
    isInStock: inStockValuesForDimension !== undefined && inStockValuesForDimension?.has(dimensionValue)
  }));

export const generateShoppablePostShareObj = (title: string, postId: string, baseUrl: string) => {
  const SHOPPABLE_POST_URL = `${baseUrl}${INFLUENCER_SHOPPABLE_POST_CUSTOMER_VIEW}${postId}`;
  return {
    link: SHOPPABLE_POST_URL,
    name: title,
    style: '',
    image: ''
  };
};

export const convertContentToShoppablePost = (content: InfluencerContent) => ({
  ...content,
  postType: content.contentType,
  postId: content.contentId
});

export const generateLabelForProduct = (product: FormattedProductBundle, style: ProductStyle) => {
  const { brandName = '', productName = '', productRating = '' } = product;
  const { color = '', price = '' } = style;
  const encodedBrandName = makeAscii(brandName);
  const encodedProductName = makeAscii(productName);
  let label = `${encodedBrandName} - ${encodedProductName}.`;
  label = color ? `${label} Color ${color}.` : label;
  label = price ? `${label} Price ${price}.` : label;
  label = parseInt(productRating) > 0 ? `${label} ${productRating} out of 5 stars.` : label;
  return label;
};

// Format: https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/InfluencerContent.proto
export const transformContentForAmethystEvent = (content: InfluencerContent, index: number) => {
  const {
    contentId,
    contentType,
    additionalMetadata: { brandName }
  } = content;
  return {
    contentId,
    contentType: INFLUENCER_CONTENT_TYPE[contentType],
    brandName,
    index
  };
};
